import PropTypes from 'prop-types';

import './CenteredBlock.css';

/**
 * Centered block for content placed inside relatively positioned parent
 * @component
 */
export const CenteredBlock = ({ children }) => {
	return <div className="centered-block">{children}</div>;
};

CenteredBlock.propTypes = {
	// Centered block content
	children: PropTypes.node.isRequired,
};

export default CenteredBlock;
